import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class ReceivingEditForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				'sellerId',
				'isAutomated',
				'warehouseFromId',
				'warehouseToId',
				'ref',
				'estimatedReceivingDate',
				'actualReceivingDate',
				'receivingStatus',
				'receivingType',
				'cost',
				'products',
				'products[].id',
				'products[].quantity',
				'products[].description',
				'products[].selectedProduct',
				'products[].isReceived',
				'products[].isAutomated',
				'products[].palletCount',
			],
			labels: {
				sellerId: 'CONTAINERFORM.SELLER',
				isAutomated: 'CONTAINERFORM.AUTOMATED',
				warehouseFromId: 'CONTAINERFORM.WAREHOUSEFROM',
				warehouseToId: 'CONTAINERFORM.WAREHOUSETO',
				ref: 'CONTAINERFORM.REF',
				estimatedReceivingDate: 'CONTAINERFORM.ESTIMATEDRECEIVINGDATE',
				receivingStatus: 'CONTAINERFORM.RECEIVINGSTATUS',
				receivingType: 'CONTAINERFORM.RECEIVINGTYPE',
				actualReceivingDate: 'CONTAINERFORM.ACTUALRECEIVINGDATE',
				cost: 'CONTAINERFORM.COST',
				'products[].selectedProduct': 'CONTAINERFORM.PRODUCT',
				'products[].quantity': 'CONTAINERFORM.QUANTITY',
				'products[].description': 'CONTAINERFORM.DESCRIPTION',
				'products[].isReceived': 'CONTAINERFORM.ISRECEIVED',
				'products[].palletCount': 'CONTAINERFORM.PALLETQUANTITY',
			},
			rules: {
				receivingStatus: 'required',
				ref: 'required',
				estimatedReceivingDate: 'required',
				receivingType: 'required',
				'products[].selectedProduct': 'required',
				'products[].quantity': 'required|numeric|numericMinValue|notZero|integer',
			},
			types: {
				isAutomated: 'checkbox',
				'products[].isReceived': 'checkbox',
				'products[].isAutomated': 'checkbox',
			},
			disabled: {
				isAutomated: true,
			},
		};
	}
}
